import { useEffect } from 'react';
import { MdAdd, MdClose, MdOutlineDone } from 'react-icons/md';

import { useStaging, useStore } from '@spazious/dollhouse-store';
import { ControlsModeEnum, DrawCamerapathStateEnum } from '@spazious/dollhouse-types';
import { Button, Stack, StackProps } from '@spazious/dollhouse-uikit';

import { useDrawCamerapath } from '../../hooks/index.js';

export interface CamerapathToolControlsProps extends StackProps {}

export const CamerapathToolControls: React.FC<CamerapathToolControlsProps> = (props) => {
  const { set: setCameraPath, active, state: drawCamerapathState } = useDrawCamerapath();

  const { set } = useStore();
  const { staging } = useStaging();

  useEffect(() => {
    // switching to other tools, reset any uncommitted changes
    return () => {
      if (staging.stack.length) {
        staging.abort();
      }
      setCameraPath({ active: false, state: DrawCamerapathStateEnum.Initial });
    };
  }, [staging, setCameraPath]);

  return (
    <Stack {...props} justifyContent="center">
      {!active && (
        <Button
          size="extraSmall"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            set({
              controls: ControlsModeEnum.Zenithal,
            });
            setCameraPath({ active: true });
          }}
        >
          <MdAdd />
        </Button>
      )}
      {active && drawCamerapathState === DrawCamerapathStateEnum.Drawing && (
        <Button
          size="extraSmall"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setCameraPath({
              state: DrawCamerapathStateEnum.Done,
            });
          }}
        >
          <MdOutlineDone />
        </Button>
      )}
      {active &&
        (drawCamerapathState === DrawCamerapathStateEnum.Initial ||
          drawCamerapathState === DrawCamerapathStateEnum.Drawing) && (
          <Button
            size="extraSmall"
            style={{ cursor: 'pointer' }}
            onClick={() =>
              setCameraPath({
                active: false,
                state: DrawCamerapathStateEnum.Cancel,
              })
            }
          >
            <MdClose />
          </Button>
        )}
    </Stack>
  );
};
